import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../AccountListView.js";

export class ZIDXAccountAIConversations implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountAIConversationsContainer";
    }
    render(){
        // console.log("AI Conversations");
        let listView=new ZIDXAccountListView(this.zidx);
        listView.render();
    }
}